import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TenantAuthConfig = React.lazy(() =>
    import('../TenantAuthConfig')
);
const tenantAuthConfigRoutesRegistry = [
    {
        path: PAGE_URL.TENANT_AUTH_CONFIG_PAGE,
        element: <TenantAuthConfig />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tenantAuthConfigRoutesRegistry;

